import React, { useContext, useEffect, useState } from 'react';
import intl from 'react-intl-universal';
import { Tooltip } from 'antd';
import RoleList from './RoleList';
import ProductList from './ProductList';
import { PayContext } from './ContextProvider';
import './PaymentDlg.scss';
import Lock from '@/assets/PaymentDlg/lock.svg';
import ProdIcon from '@/assets/PaymentDlg/bProd.svg';
import { paymentApi } from '@/api';
import { getCurrencySymbol } from 'Utils/utils';

const EduLeftTip = ({ detail }) => {
  const { appCode, name, show_name, licenseSymbol, licensePrice, license } = detail;
  const { formKey, store } = useContext(PayContext);
  const [planDetail, setPlanDetail] = useState({
    licenseSymbol: '',
    licensePrice: 0,
  });

  const security = intl.formatMessage({ id: 'account.SecurityLock' });
  const securityTitle = intl.formatMessage({ id: 'account.SecurityLockTitle' });
  const taxTip = intl.formatMessage({ id: 'account.TaxTips' });
  const BilledMonthly = intl.formatMessage({ id: 'account.BilledMonthly' });
  const BilledYearly = intl.formatMessage({ id: 'account.BilledYearly' });
  const BilledYearMonthly = intl.formatMessage({ id: 'account.BilledYearMonthly' });
  const Month = intl.formatMessage({ id: 'account.Month' });
  const Year = intl.formatMessage({ id: 'account.Year' });
  const EduPlanInclude = intl.formatMessage({ id: 'account.EduPlanInclude' });

  const LicenseUnitMap = {
    'monthly-year': {
      price: 'subscription-monthly-year', unit: Month,
    }, 'yearly': {
      price: 'subscription_discount_price', unit: Year,
    }, 'monthly': {
      price: 'subscription-monthly_discount_price', unit: Month,
    },
  };
  const LicenseTipMap = {
    'monthly-year': BilledYearMonthly, 'yearly': BilledYearly, 'monthly': BilledMonthly,
  };

  const ip = store.appStore.phantomOnlineGlobalConfig.userIp || '';

  const getPrice = async () => {
    const res = await paymentApi.getPaymentPlans({
      country: formKey.country,
      currency: formKey.currency,
      ip,
      app_code: appCode,
      language: 'en-US',
      token: store.userStore.token,
    });

    if (res.code === 200 && res.message.toLowerCase() === 'success') {
      let realPrice = {};
      if ('windows' in res.data) {
        realPrice = res.data.windows;
      } else if ('mac' in res.data) {
        realPrice = res.data.mac;
      }
      const finalPrice = { ...res.data, ...realPrice };
      const { currentCurrency: { code, symbol } } = res.data;
      const showSymbol = getCurrencySymbol(code, symbol);
      setPlanDetail(old => ({
        ...old, ...{
          licenseSymbol: showSymbol,
          licensePrice: finalPrice[LicenseUnitMap[license].price],
        },
      }));
    }
  };

  useEffect(() => {
    setPlanDetail({ licenseSymbol, licensePrice });
  }, [licenseSymbol, licensePrice]);

  useEffect(() => {
    const fn = async () => {
      await getPrice();
    };
    formKey.country && formKey.currency && fn();
  }, [formKey.country, formKey.currency]);

  return (
    <div className='edu-left-box'>
      <div className='bcb-title'>
        <img src={ProdIcon} alt={name} />
        <span dangerouslySetInnerHTML={{ __html: show_name }}></span>
      </div>

      <p className='elb-price'>
        <span>{planDetail.licenseSymbol}{planDetail.licensePrice}</span>
        <span>/{LicenseUnitMap[license].unit}</span>
      </p>
      <p className='elb-tip'>{LicenseTipMap[license]}</p>
      <div className='line' />
      <p className='edu-plan-include'>{EduPlanInclude}:</p>
      {appCode === 'pdf_editor_ps_education_pro' && <ProductList small />}
      {appCode === 'pdf_editor_cloud_education' && <RoleList small />}

      <div className='sec-bottom'>
        <Tooltip overlayClassName='sec-bottom-title' title={securityTitle}
                 placement='topLeft' color='#ffffff'>
          <img src={Lock} alt={security} />
          <span>{security}</span>
        </Tooltip>
        <p>{taxTip}</p>
      </div>
    </div>
  );
};
export default EduLeftTip;